import React from 'react';

const Services = () => (
  <section className="py-20 px-4 bg-gray-50 text-center">
    <h2 className="text-3xl font-bold mb-8">Our Services</h2>
    <div className="max-w-5xl mx-auto grid md:grid-cols-3 gap-8">
      <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition">
        <h3 className="text-xl font-semibold mb-2">Industrial Water Treatment</h3>
        <p>Efficient solutions to purify and recycle water for industrial processes.</p>
      </div>
      <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition">
        <h3 className="text-xl font-semibold mb-2">Wastewater Management</h3>
        <p>Safe treatment and disposal of wastewater with sustainable practices.</p>
      </div>
      <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition">
        <h3 className="text-xl font-semibold mb-2">Water Quality Testing</h3>
        <p>Comprehensive water testing to ensure safety and compliance standards.</p>
      </div>
    </div>
  </section>
);

export default Services;
